$( document ).ready(function() {

  // PROJECT TAGS
  $( ".project-tags" ).each(function( index ) {
    var el = $(this);
    var number = el.children(".project-tag").length;
    if(number > 2){
      el.addClass("hide");
      el.append('<div class="show-tags"><div class="show-tags-shape"><svg x="0px" y="0px" viewBox="0 0 10 2" style="enable-background:new 0 0 10 2;" xml:space="preserve"><g><path class="st0" d="M1,0L1,0c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1l0,0C0.4,2,0,1.6,0,1l0,0C0,0.4,0.4,0,1,0z"/><path class="st0" d="M5,0L5,0c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1l0,0C4.4,2,4,1.6,4,1l0,0C4,0.4,4.4,0,5,0z"/><path class="st0" d="M9,0L9,0c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1l0,0C8.4,2,8,1.6,8,1l0,0C8,0.4,8.4,0,9,0z"/></g></svg></div></div>'); 
    }
  });
  $('.show-tags-shape').on('click', function() {
    $(this).parent().parent(".project-tags").toggleClass("show");
  });

  // CART TRIGGER
  function cartTrigger(){
    var ww = $(window).width();
    if(ww < 821){
      $("#cart-trigger").appendTo("#logo-menu-container");
    } else {
      $("#cart-trigger").appendTo(".shop-cart-container");
    }
  }
  cartTrigger();
  $( window ).on( "resize", function() {
    cartTrigger();
  });

  // BACK BUTTON
  var backTrigger = document.querySelector('.back-trigger');
  if (backTrigger) {
      backTrigger.addEventListener('click', function () {
          window.history.back();
      });
  }

  var swiperNews = new Swiper('.news-swiper-footer', {
    direction: 'horizontal',
    loop: true,
    speed: 0,
    allowTouchMove: false,
    autoHeight: true,
    navigation: {
      nextEl: '.news-swiper-navigation-button-next',
      prevEl: '.news-swiper-navigation-button-prev',
    },
    pagination: {
      el: '.news-card-container-header-count-pagination',
      type: 'fraction',
      clickable: true,
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + ' <span>/</span> ' + '<span class="' + totalClass + '"></span>';
      },
    },
  });   
  var swiperNewsIntro = new Swiper('.news-swiper-footer-intro', {
    direction: 'horizontal',
    loop: true,
    speed: 0,
    allowTouchMove: false,
    autoHeight: true,
    navigation: {
      nextEl: '.news-swiper-navigation-button-next-intro',
      prevEl: '.news-swiper-navigation-button-prev-intro',
    },
    pagination: {
      el: '.news-card-container-header-count-pagination-intro',
      type: 'fraction',
      clickable: true,
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + ' <span>/</span> ' + '<span class="' + totalClass + '"></span>';
      },
    },
  });   
  swiperNews.on('slideChangeTransitionEnd', function () {
    handleResize();
  });
  function handleResize() {
    var footerNewsElement = document.getElementsByClassName('footer-news')[0];
    var legalCopyrightElement = document.getElementsByClassName('legal-copyright')[0];
    var elementHeight = footerNewsElement.offsetHeight;
  }
  handleResize();
  window.addEventListener('resize', handleResize);

  // READ MORE NEWS
  $('.news-card-content-read').click(function () {
    $(this).prev('.news-card-content-description').slideToggle(300);
    $(this).find("span").toggle();
    setTimeout(function(){
      swiperNews.updateAutoHeight(300);
      swiperNewsIntro.updateAutoHeight(300);
    }, 300);
    setTimeout(function(){
      handleResize();
    }, 650);
  });

  // MOBILE MENU
  $("#menu-mobile-trigger, #close-menu").click(function () {
    $("#menu-mobile").toggleClass("show");
  });

  // HOMEPAGE CLICK
  $(".homepage-project-image").click(function () {
    var href = $(this).attr("data-href");
    window.location.href = href;
  });

  $('.about-careers-job').click(function () {
    $(".close-button").addClass("black");
    $(".close-button").fadeIn(300);
    $(this).next(".info-overlay-container").fadeIn(300);
    $(".bottom-gradient").addClass("show");
    $("body").addClass("noscroll");
  });

  $('.news-trigger').click(function () {
    $(".close-button, .bottom-gradient").addClass("black news");
    $(".close-button, #news-overlay-background").fadeIn(300);
    $(".bottom-gradient").addClass("show");
    $("#news-overlay-container").addClass("show");
    $("body").addClass("noscroll");
    $("#menu-mobile").removeClass("show");
  });
  
  // INFORMATION & OVERVIEW
  $('.info-trigger').on('click', function() {
    $(".info-overlay-container, .close-button").fadeIn(300);
    $(".bottom-gradient").addClass("show");
    $("body").addClass("noscroll");
  });
  $("#news-back-exit").on('click', function() {
    $('.close-button').click();
  });
  $('.close-button').on('click', function() {
    $(".info-overlay-container, .close-button, #swiper-overview-container, #news-overlay-background").fadeOut(300);
    $("#news-overlay-container, .bottom-gradient").removeClass("show");
    $("body").removeClass("noscroll");
    $(".bottom-gradient").removeClass("black news");
    setTimeout(function(){
      $(".close-button").removeClass("black news");
    }, 500);
  });

  $('.overview-trigger').on('click', function() {
    $("#swiper-overview-container, .close-button").fadeIn(300);
    $("body").addClass("noscroll");
    setTimeout(function(){
      var swiperWrapper = document.getElementById('swiper-wrapper-drag');
      if (!swiperWrapper) {
          console.error('Element with ID swiper-wrapper-drag not found.');
          return;
      }
      
      var totalWidth = 12;
      var wwww = $(window).width() - 32;
      $( "#swiper-wrapper-drag .image-in-block" ).each(function( index ) {
        var width = $(this).width();
        totalWidth = totalWidth + width + 4;
      });
      
      if(wwww > totalWidth){
        $("#swiper-wrapper-drag").addClass("centered");
      } else {
        $("#swiper-wrapper-drag").removeClass("centered");
      }
    }, 10);
  });

  $( window ).on( "resize", function() {
    var totalWidthrs = 12;
    var wwwwrs = $(window).width() - 32;
    $( "#swiper-wrapper-drag .image-in-block" ).each(function( index ) {
      var width = $(this).width();
      totalWidthrs = totalWidthrs + width + 4;
    });
    if(wwwwrs > totalWidthrs){
      $("#swiper-wrapper-drag").addClass("centered");
    } else {
      $("#swiper-wrapper-drag").removeClass("centered");
    }
  });

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  const windowHeightStatic = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height-static', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    const windowHeightStatic = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height-static', `${windowHeight}px`);
  });

  // LAZY LOAD
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            l.src = l.dataset.src;
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });

  window.addEventListener("pageshow", function() {
    $("body").removeClass("fade-out");
  }, false);

  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 1000);

  // INTRO
  $( "#new-intro" ).click(function() {
    $(this).fadeOut(250);
    $("body").removeClass("noscroll");
  });

  // FRIEND INFO
  $( "#size-mobile" ).click(function() {
    $(this).children("span").toggle();
    $( "#product-grid" ).toggleClass("big");
  });

  // FRIEND INFO
  $( "#information-trigger" ).click(function() {
    $(this).children("span").toggle();
    $( "#information-content" ).toggle();
  });
  
  // PRODUCT INFO
  $( ".product-info-trigger" ).click(function() {
    $(this).children("span").toggle();
    $(this).parent(".product-bar").children(".product-info").slideToggle();
  });
  
  // SELECT FIRST VARIANT
  const myTimeout = setTimeout(myGreeting, 500);
  function myGreeting() {
    $( ".variant-input-label" ).first().addClass("selected-size-label");
  }
  
  // PRODUCT EXCERPT
  $( ".product" ).each(function() {
    var excerpt = $( this ).children(".product-bar").children(".product-info").children("p").children("em").text();
    $( this ).children(".product-bar").children(".product-excerpt").text(excerpt);
  });

  
  // QTY IN PRODUCT
  $( ".qty-plus" ).click(function() {
    var curqty = $("#qty").attr("value"),
        pluqty = parseInt(curqty) + 1,
        total = $("#qty").attr("max");
    if(pluqty == total){
      $("#product-add-qty").addClass("maximum");
    }
    $("#qty").attr("value", pluqty);
    $("#product-add-qty").removeClass("minimum");
  });
  $( ".qty-minus" ).click(function() {
    var curqty = $("#qty").attr("value"),
        minqty = parseInt(curqty) - 1
    if(minqty != 0){
      $("#qty").attr("value", minqty);
    }
    if(minqty == 1){
      $("#product-add-qty").addClass("minimum");
    }
    $("#product-add-qty").removeClass("maximum");
  });

    // QTY PRODUCT
  $( ".minus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) - 1;
    if (getValue > 0) {
      $("#qty").val(getValue);
      $("#qty").attr("value", getValue);
    }
  });
  $( ".plus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) + 1;
    $("#qty").val(getValue);
    $("#qty").attr("value", getValue);
  });
  
  // TOGGLE MINICART
  $( "#cart-trigger, #cart-trigger-mobile, #close-cart" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#fakexit" ).toggle();
  });
  $( "#burger-cart" ).click(function() {
    event.preventDefault();
    $("#fakexit").toggle();
    $( "#mini-cart" ).removeClass("active");
    $("#cart-trigger").removeClass("active");
    $("#burger-cart").removeClass("active");
    $("#header-bar").removeClass("active-home");
  });
  $( "#mini-cart-close, #fakexit" ).click(function() {
    $("#fakexit").hide();
    $( "#mini-cart" ).removeClass("active");
  });

  // TRIGGER ALL
  $( "#all-trigger" ).click(function() {
    event.preventDefault();
    $(this).addClass("super-trigger");
  });
  
  // HIDE VARIANT IF EMPTY
  $( ".product-variant-cart" ).each(function() {
    var variantTitle = $( this ).text();
    if (variantTitle == "Default Title") {
      $( this ).hide();
    }
  });
  
  // BACK TO TOP
  $("#back-to-top").click(function () {
     $("html, body").animate({scrollTop: 0}, 1000);
  });
  
  // TRIGGER MOBILE MENU
  $("#menu-trigger-mobile").click(function () {
     $(this).children("span").toggle();
     $("nav").toggle();
     $("#menu-desktop a:first-child").toggle();
  });
  
  // BACK TO TOP
  $("#grid-trigger").click(function () {
     $("main").toggleClass("grid");
  });

  // ADD/REMOVE ITEM
  $( ".cart-product-quantity .plus" ).each(function() {
    var max = $(this).attr("data-inventory"),
        el = $(this);
    if(parseInt(el.prev(".quantity-wrap").text()) == parseInt(max)){
      el.addClass("maximum");
    }
  });
  setTimeout(function(){
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      var symbol = $("#mini-cart").attr("data-symbol");
      var code = $("#mini-cart").attr("data-code");
      if(len < 4){
        $(".mini-cart-subtotal-price-to-change").text(symbol + totalmoney + " " + code);
      } else {
        $(".mini-cart-subtotal-price-to-change").text(symbol + totalmoney + " " + code);
      }
      if(itemscount == 0){
        $( "#cart-trigger" ).click();
        $("#cart-trigger").addClass("disabled");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger span").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    if(currentVal + 1 >= maxinv) {
      e.target.classList.add("maximum");
    }
    if(currentVal >= maxinv) {
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var plusTrigger = $(e.target).parent('div').children('.plus');
    
    plusTrigger.removeClass("maximum");
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  
});